import {FiltersProps, ResourceProps} from "@models/new-resource";
import {Actions} from "@redux/actions/new-resource";

export interface QuickLinkState {
    smartFilter: any
}

export const QUICK_LINK_REDUCER_NAMESPACE = 'quickLinkReducer'

let defaultstate: QuickLinkState = {
    smartFilter: {}
}

export default (state = defaultstate, action) => {
    switch (action.type) {
        case Actions.SET_SMART_FILTER:
            return {
                ...state,
                smartFilter: action.value,
            }
        default:
            return state
    }
}
